import React, { useEffect, useRef, useState } from 'react'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { Container } from './styles'
import ViewPage from '../../../Components/ViewPage'
import { TitleH1 } from '../../../Components/CustomUi/titleH1'
import { TabelaTesteBandeja } from './components/tabela'
import {
  useGetTesteBandeja,
  useGetTesteBandejaCalculo,
  useGetTesteBandejaEditar,
} from '../../../services/relatorioTesteBandeja/GET'
import { Drawer } from 'antd'
import { NavegacaoDrawer } from '../recomendacao/novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import ButtonCustom from '../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint, faXmark } from '@fortawesome/free-solid-svg-icons'
import { TabelaMedicaoBandeja } from './components/tabelaMedição'
import { Relatorios } from './components/relatorio'
import { useReactToPrint } from 'react-to-print'
import { useAccess } from '../../../context/useAccess'
import dayjs from 'dayjs'

const RelatorioTesteBandeja: React.FC = () => {
  const refPdfPrint = useRef<HTMLDivElement>()

  const { nameCliente } = useAccess()

  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [open, setOpen] = useState(false)
  const [openRelatorio, setOpenRelatorio] = useState(false)
  const [update, setUpdate] = useState<number>(null)
  const [updateRelatorio, setUpdateRelatorio] = useState<number>(null)
  const [tab_selecionar_atual, setTab_selecionar_atual] = useState<
    'Resumo' | 'Gráficos' | 'Sugestões'
  >('Resumo')
  const [totalDadosGrafico, setTotalDadosGrafico] = useState([])
  const [buscarTabela, setBuscarTabela] = useState('')
  const [data, setData] = useState('')

  //IMPRESSAO
  const [gerando, setGerando] = useState<boolean>(false)
  const [renderizarGraficos, setRenderizarGraficos] = useState<boolean>(false)
  const [esconderSwitch, setEsconderSwitch] = useState<boolean>(false)
  const [graficoSelecionados, setGraficoSelecionados] = useState([])
  const [todosSelecionado, setTodosSelecionado] = useState<boolean>(false)
  const [imprimirGraficos, setImprimirGraficos] = useState<boolean>(false)
  const [mostrarGraficos, setMostrarGraficos] = useState<boolean>(true)
  const [mostrarResumo, setMostrarResumo] = useState<boolean>(true)
  const [mostrarSugestao, setMostrarSugestao] = useState<boolean>(true)
  const [abrirConfig, setAbrirConfig] = useState<boolean>(false)
  const [propriedade, setPropriedade] = useState('')
  const [nome_equipamento, setNome_equipamento] = useState('')
  const [realizado_por, setRealizado_por] = useState('')
  const [nome_consultor, setNome_consultor] = useState<string>('')

  const nomeArquivo = `Teste de bandeja - ${nameCliente} - ${dayjs(data).format('DD/MM/YYYY')}`

  const { carregando_teste_bandeja, data_teste_bandeja, refetch_data_teste_bandeja } =
    useGetTesteBandeja(pagination, page, buscarTabela)

  const {
    carregando_teste_bandeja_editar,
    data_teste_bandeja_editar,
    refetch_data_teste_bandeja_editar,
  } = useGetTesteBandejaEditar(update)

  const { carregando_teste_bandeja_calculo, data_teste_bandeja_calculo } =
    useGetTesteBandejaCalculo(update, updateRelatorio)

  const desativar = data_teste_bandeja_calculo?.map((item) => item?.calculo)

  function abrirGaveta(cod, propriedade, nome_equipamento, nome_usuario, data) {
    setOpen(true)
    setUpdate(cod)
    setPropriedade(propriedade)
    setNome_equipamento(nome_equipamento)
    setRealizado_por(nome_usuario)
    setData(data)
  }

  function abrirGavetaRelatorio(cod) {
    setOpenRelatorio(true)
    setUpdateRelatorio(cod)
  }

  function fecharGaveta() {
    setOpen(false)
    setUpdate(null)
  }

  function fecharGavetaRelatorio() {
    setOpenRelatorio(false)
    setTab_selecionar_atual('Resumo')
    setUpdateRelatorio(null)
    setGraficoSelecionados([])
    setEsconderSwitch(false)
    setImprimirGraficos(false)
    setGerando(false)
    setAbrirConfig(false)
  }

  function graficosSelecionadosImprimir(checked, id) {
    setGraficoSelecionados((prev) => {
      if (checked) {
        return [...prev, id]
      } else {
        return prev.filter((itemId) => itemId !== id)
      }
    })
  }

  function selecionarTodosGraficos(checked, dados) {
    if (checked) {
      setGraficoSelecionados(dados.map((item) => item?.cod))
    } else {
      setGraficoSelecionados([])
    }
  }

  function tirarSwitchImprimir() {
    setAbrirConfig(true)
  }

  function imprimir() {
    setEsconderSwitch(true)
    setImprimirGraficos(true)
    setGerando(true)
    setTab_selecionar_atual('Gráficos')
    setAbrirConfig(false)
    setTimeout(() => {
      handlePrint()
    }, 4000)
  }

  const handlePrint = useReactToPrint({
    content: () => refPdfPrint.current,
    documentTitle: nomeArquivo,
    onBeforeGetContent: () => {
      document.title = nomeArquivo
    },
    onAfterPrint() {
      setEsconderSwitch(false)
      setImprimirGraficos(false)
      setTab_selecionar_atual('Resumo')
      setGerando(false)
      setMostrarGraficos(true)
      setMostrarResumo(true)
      setMostrarSugestao(true)
      setNome_consultor('')
      document.title = 'ttivos - gestão rural'
    },
  })

  useEffect(() => {
    refetch_data_teste_bandeja()
  }, [])

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        refetch_data_teste_bandeja()
      }, 700)
    }
    if (buscarTabela === '') {
      refetch_data_teste_bandeja()
    }
  }, [buscarTabela])

  useEffect(() => {
    refetch_data_teste_bandeja()
  }, [page, pagination])

  useEffect(() => {
    if (update > 0) {
      refetch_data_teste_bandeja_editar()
    }
  }, [update])

  useEffect(() => {
    if (todosSelecionado && totalDadosGrafico.length > 0) {
      setGraficoSelecionados(totalDadosGrafico.map((item) => item?.cod))
    } else {
      setGraficoSelecionados([])
    }
  }, [todosSelecionado, totalDadosGrafico])

  return (
    <Container>
      <ViewPage
        title='Teste de bandeja'
        btnClick={null}
        newHide
        rotina={103}
        onPermission={setPermissions}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Teste de bandeja</TitleH1>
        </div>

        <TabelaTesteBandeja
          loading={carregando_teste_bandeja}
          setPagination={setPagination}
          page={page}
          setPage={setPage}
          total={data_teste_bandeja?.total}
          listar_teste_bandeja={data_teste_bandeja?.itens}
          abrirGaveta={abrirGaveta}
          buscar_tabela={buscarTabela}
          setBuscar_tabela={setBuscarTabela}
        />

        <Drawer
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={() => fecharGaveta()}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
          open={open}
          width={750}
          onClose={() => fecharGaveta()}
          closable={false}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: '10px 10px' }}
        >
          <TabelaMedicaoBandeja
            loading={carregando_teste_bandeja_editar}
            listar_teste_medicao={data_teste_bandeja_editar}
            abrirGaveta={abrirGavetaRelatorio}
            desativar={desativar?.length <= 0}
          />
        </Drawer>
        <Drawer
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={() => fecharGavetaRelatorio()}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
          open={openRelatorio}
          width={830}
          onClose={() => fecharGavetaRelatorio()}
          closable={false}
          bodyStyle={{
            padding: 0,
            overflowY: tab_selecionar_atual === 'Gráficos' ? 'hidden' : 'auto',
            overflowX: 'hidden',
          }}
          headerStyle={{ padding: '10px 10px' }}
          footer={
            <div style={{ display: 'flex', gap: '10px' }}>
              <ButtonCustom
                type='primary'
                onClick={tirarSwitchImprimir}
                icon={<FontAwesomeIcon icon={faPrint} />}
                disabled={gerando || carregando_teste_bandeja_calculo}
                loading={gerando}
              >
                {gerando ? 'Gerando...' : 'Gerar impressão'}
              </ButtonCustom>
            </div>
          }
        >
          <Relatorios
            tab_selecionar_atual={tab_selecionar_atual}
            setTab_selecionar_atual={setTab_selecionar_atual}
            nome_consultor={nome_consultor}
            setNome_consultor={setNome_consultor}
            listar_teste_relatorios={data_teste_bandeja_calculo}
            loading={carregando_teste_bandeja_calculo}
            pdfRefPrint={refPdfPrint}
            esconderSwitch={esconderSwitch}
            setTotalDadosGrafico={setTotalDadosGrafico}
            graficoSelecionados={graficoSelecionados}
            graficosSelecionadosImprimir={graficosSelecionadosImprimir}
            selecionarTodosGraficos={selecionarTodosGraficos}
            todosSelecionados={todosSelecionado}
            setTodosSelecionados={setTodosSelecionado}
            mostrarGraficos={mostrarGraficos}
            setMostrarGraficos={setMostrarGraficos}
            mostrarResumo={mostrarResumo}
            setMostrarResumo={setMostrarResumo}
            mostrarSugestao={mostrarSugestao}
            setMostrarSugestao={setMostrarSugestao}
            abrirConfig={abrirConfig}
            setAbrirConfig={setAbrirConfig}
            gerando={gerando}
            renderizarGraficos={renderizarGraficos}
            setRenderizarGraficos={setRenderizarGraficos}
            imprimirGraficos={imprimirGraficos}
            propriedade={propriedade}
            nome_equipamento={nome_equipamento}
            realizado_por={realizado_por}
            imprimir={imprimir}
          />
        </Drawer>
      </ViewPage>
    </Container>
  )
}

export default RelatorioTesteBandeja
